export {
  CapitalDetails,
  GetIsFbReport,
  GetRWHistory,
  Pay,
  RefreshExchangeRate,
  UpayStatusorderNo,
  VnRechargeInitS
} from '@/api/common'
